import styled from 'styled-components';
import { defaultBoxShadow, Flex } from 'UI';

export const TireReferencesPopupContainer = styled(Flex)<{ marginTop?: number }>`
  position: absolute;
  width: 100%;
  left: 0;
  z-index: 10;
  overflow-y: auto;
  padding: 15px;
  background-color: ${({ theme }) => theme.color.white};
  margin-top: ${({ marginTop }) => `${marginTop}px`};
  min-width: min(760px, calc(100vw - 32px));
  max-width: 100%;
  box-sizing: border-box;
  ${defaultBoxShadow};
`;
